import { Component, h, Prop, Element } from '@stencil/core';
import { ColorThemesTypes, LogoInterface } from "../../utils";

@Component({
  tag: 'snap-global-header',
  styleUrl: 'snap-global-header.scss'
})
export class SnapGlobalHeader {
  @Prop({ reflect: true }) theme: ColorThemesTypes = 'mobile'
  @Element() private el: HTMLElement
  private logo: LogoInterface
  private ro: ResizeObserver

  componentWillLoad() {
    this.logo = Array.from(this.el.children)[0] as unknown as LogoInterface
    this.logo.product = `snap-logo-${this.theme}`

    this.ro = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.contentRect.width < 768) {
          this.logo.variant = 'stacked'
        }
        else if (entry.contentRect.width < 992) {
          this.logo.variant = 'compact'
        }
        else if (entry.contentRect.width >= 992) {
          this.logo.variant = '1line'
        }
      }
    });
    this.ro.observe(this.el);
  }

  disconnectedCallback() {
    this.ro.disconnect();
  }


  render() {
    return (
      <div class={`snap-global-header snap-global-header--${this.theme}`}>
        <slot />
      </div>
    );
  }

}
